import { Action, createLogic, Logic } from "redux-logic";

import { saveMapSettings } from "api/video/map";

import history from 'utils/history';

import { actions as appActions } from "reducer/app";
import { actions as mapActions, actionTypes as mapActionTypes } from "reducer/map";
import { IRootState } from "reducer";

import { IMapSettings } from "views/components/Video/MapComponent";


export const savePosition = createLogic({
    type: mapActionTypes.SAVE_CURRENT_POSITION,
    latest: true,
    warnTimeout: 0,

    async process({getState, action}: { getState: () => IRootState, action: {payload: {settings: IMapSettings}}}, dispatch, done) {
        dispatch(appActions.toggleSpinner({value: true}));
        saveMapSettings({coords: action.payload.settings})
            .then(() => {
                dispatch(appActions.toggleSpinner({value: false}));
            })
}});

export default [
    savePosition as Logic
];